import React, { Component, Fragment } from 'react'
import axios, { getParticipantInfo, getAccessToken } from '../Shared/axios'
import { Helmet } from 'react-helmet'
import InfiniteScroll from 'react-infinite-scroller'
import Loading from '../Shared/Loading'
import { requestGetApi } from '../Shared/utils'
import { Input, Icon, Alert } from 'loyal-react'
import BranchModal from './BranchModal'
import BranchModalDelete from './BranchModalDelete'
import Empty from '../Shared/Empty'
import PropTypes from 'prop-types'

class Branch extends Component {
  constructor (props) {
    super(props)
    this.state = {
      branches: [],
      loading: true,
      branchesFiltered: [],
      infiniteOffset: 0,
      infiniteLimit: 5,
      infiniteHasMore: false,
      search: '',
      modal: false,
      modalDelete: false,
      name: '',
      branchId: null,
      successMessage: false,
      errorMessage: false
    }
  }

  async componentDidMount () {
    await this.getParticipant()
    await this.getBranches()
  }

  async getParticipant () {
    this.updateState('loading', true)

    const participant = getParticipantInfo()
    const response = await requestGetApi(`participant/${participant.username}`)

    if (!response || response.parentId !== null) this.navigate()

    this.updateState('loading', false)
  }

  navigate () {
    this.props.history.push('/')
  }

  async getBranches () {
    this.updateState('loading', true)

    const response = await requestGetApi('branch')
    const branchesSorted = response ? response.sort(this.sortName) : []

    this.updateState('branches', branchesSorted)
    this.updateState('infiniteHasMore', true)
    this.updateState('loading', false)
  }

  filterBranches () {
    if (this.state.infiniteHasMore) {
      const branches = this.state.branches
      const offset = this.state.infiniteOffset
      const limit = this.state.infiniteLimit
      let branchesFiltered = this.state.branchesFiltered

      for (let i = offset; i < limit; i++) {
        if (!branches[i]) break
        branchesFiltered.push(branches[i])
      }

      if (branchesFiltered.length === branches.length) {
        this.updateState('infiniteHasMore', false)
      }

      this.updateState('branchesFiltered', branchesFiltered)
    }
  }

  loadMore () {
    this.filterBranches()
    this.updateState('infiniteOffset', this.state.infiniteOffset + 5)
    this.updateState('infiniteLimit', this.state.infiniteLimit + 5)
  }

  handleChangeSearch (value) {
    this.updateState('search', value)
    this.updateState('branchesFiltered', [])
    this.updateState('infiniteHasMore', false)

    if (value === '') {
      this.updateState('infiniteOffset', 0)
      this.updateState('infiniteLimit', 5)
      this.updateState('infiniteHasMore', true)
    } else {
      this.searchBranches()
    }
  }

  searchBranches () {
    const branches = this.state.branches
    const search = this.state.search
    let branchesFiltered = []

    for (let branch of branches) {
      if (branch.name.toLowerCase().includes(search)) {
        branchesFiltered.push(branch)
      }
    }

    this.updateState('branchesFiltered', branchesFiltered)
  }

  editBranch (branch) {
    this.updateState('branchId', branch.id)
    this.updateState('name', branch.name)
    this.toggleModal()
  }

  async submitBranch () {
    this.updateState('infiniteHasMore', false)
    const branchId = this.state.branchId
    const branchName = this.state.name

    this.toggleModal()
    this.updateState('loading', true)

    this.updateState('successMessage', false)
    this.updateState('errorMessage', false)

    const method = branchId ? 'put' : 'post'
    const url = `branch${branchId ? `/${branchId}` : ''}`
    const body = { name: branchName }

    const participant = getParticipantInfo()

    const headers = {
      'Authorization': `Bearer ${getAccessToken()}`,
      'campaignId': `${participant['custom:campaign_id']}`,
      'catalogId': `${participant['custom:catalog_id']}`
    }

    await axios[method](url, body, { headers })
      .then((res) => {
        this.updateState('successMessage', { title: 'Filial salva com sucesso', description: '' })
      })
      .catch((err) => {
        console.log(err)
        this.updateState('errorMessage', { title: 'Ocorreu um erro ao salvar a filial', description: '' })
      })
      .finally(async () => {
        this.updateState('branchesFiltered', [])
        this.updateState('infiniteOffset', 0)
        this.updateState('infiniteLimit', 5)
        await this.getBranches()
      })
  }

  sortName (a, b) {
    var x = a.name.toLowerCase()
    var y = b.name.toLowerCase()
    if (x > y) return 1
    if (y > x) return -1
    return 0
  }

  handleDelete (branch) {
    this.updateState('branchId', branch.id)
    this.updateState('name', branch.name)
    this.toggleModalDelete()
  }

  async delete (branchId) {
    this.updateState('infiniteHasMore', false)
    this.toggleModalDelete()
    this.updateState('loading', true)

    const participant = getParticipantInfo()

    const headers = {
      'Authorization': `Bearer ${getAccessToken()}`,
      'campaignId': `${participant['custom:campaign_id']}`,
      'catalogId': `${participant['custom:catalog_id']}`
    }

    await axios
      .delete(`branch/${branchId}`, { headers })
      .then((res) => {
        this.updateState('successMessage', { title: 'Filial excluída com sucesso', description: '' })
      })
      .catch((err) => {
        console.log(err)
        this.updateState('errorMessage', { title: 'Ocorreu um erro ao excluir a filial', description: '' })
      })
      .finally(async () => {
        this.updateState('branchesFiltered', [])
        this.updateState('infiniteOffset', 0)
        this.updateState('infiniteLimit', 5)
        await this.getBranches()
      })
  }

  toggleModalDelete () {
    this.updateState('successMessage', false)
    this.updateState('errorMessage', false)

    let state = this.state
    state.modalDelete = !state.modalDelete

    if (!state.modalDelete) {
      this.updateState('branchId', null)
      this.updateState('name', '')
    }

    this.setState(state)
  }

  toggleModal () {
    this.updateState('successMessage', false)
    this.updateState('errorMessage', false)

    let state = this.state
    state.modal = !state.modal

    if (!state.modal) {
      this.updateState('branchId', null)
      this.updateState('name', '')
    }

    this.setState(state)
  }

  updateState = (field, value) => {
    let state = this.state
    state[field] = value
    this.setState(state)
  }

  showSuccess = (message) => {
    return message ? (
      <Alert
        isSuccess
        title={message.title}
        description={message.description}
        className='pt-2 pb-0'
        onClose={() => this.updateState('successMessage', false)}
      />
    ) : (
      ''
    )
  }

  showError = (message) => {
    return message ? (
      <Alert
        isError
        title={message.title}
        description={message.description}
        className='pt-2 pb-0'
        onClose={() => this.updateState('errorMessage', false)}
      />
    ) : (
      ''
    )
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Filiais - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid'>
          <div className='container'>
            <div className='row'>
              {this.showError(this.state.errorMessage)}
              {this.showSuccess(this.state.successMessage)}
              <div className='col-12 py-2'>
                <div className='row'>
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='row px-3 py-2 border-bottom border-color-ui-3 '>
                      <div className='col-10 py-1'>
                        <h3 className='txt-initial color-brand-1 mr-auto'>
                          Filiais
                        </h3>
                      </div>
                      <div className='col-2 py-1'>
                        <button onClick={() => this.updateState('modal', true)}>
                          Adicionar
                        </button>
                      </div>
                    </div>
                    <div className='col-12 mt-3 mb-3'>
                      <Input
                        id='search'
                        label='Buscar filial'
                        className='form-field'
                        disabled={this.state.loading}
                        onChange={(e) => this.handleChangeSearch(e.target.value)}
                      />
                    </div>
                    {this.state.loading
                      ? (
                        <Loading
                          loading={this.state.loading}
                        />
                      )
                      : (
                        this.state.branches.length > 0
                          ? (
                            <InfiniteScroll
                              pageStart={0}
                              loadMore={() => this.loadMore()}
                              hasMore={this.state.infiniteHasMore}
                            >
                              {this.state.branchesFiltered.map((b) => {
                                return (
                                  <div className='col-12 order-item'>
                                    <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
                                      <div className='order-product-info col mr-auto'>
                                        <div className='order-product-info row'>
                                          <div className='product-infos col-12 mx-0'>
                                            <h2 className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                                              {b.name}
                                            </h2>
                                          </div>
                                        </div>
                                      </div>
                                      <div className='order-action pos-relative col-1 d-none d-md-inline-block txt-center'>
                                        <div className='row align-items-center h-100'>
                                          <a
                                            onClick={() => { this.editBranch(b) }}
                                            href='javascript:void(0)'
                                            role='button'
                                            aria-label='Editar filial'
                                            className='d-inline-block ml-1'
                                          >
                                            <Icon
                                              iconName='icon_edit'
                                              className='position-relative pos-relative l-0 t-0'
                                            />
                                          </a>
                                        </div>
                                      </div>
                                      <div className='order-action pos-relative col-1 d-none d-md-inline-block txt-center'>
                                        <div className='row align-items-center h-100'>
                                          <a
                                            onClick={() => { this.handleDelete(b) }}
                                            href='javascript:void(0)'
                                            role='button'
                                            aria-label='Excluir filial'
                                            className='d-inline-block ml-1'
                                          >
                                            <Icon
                                              iconName='icon_trash'
                                              className='position-relative pos-relative l-0 t-0'
                                            />
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              })}
                            </InfiniteScroll>
                          )
                          : (
                            <Empty message='Não há filiais cadastradas' />
                          )
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
            { /* eslint-disable react/jsx-no-bind */ }
            <BranchModal
              modal={this.state.modal}
              branchName={this.state.name}
              branchId={this.state.branchId}
              toggleModal={this.toggleModal.bind(this)}
              updateState={this.updateState.bind(this)}
              submit={this.submitBranch.bind(this)}
            />
            <BranchModalDelete
              modal={this.state.modalDelete}
              branchId={this.state.branchId}
              branchName={this.state.name}
              toggleModalDelete={this.toggleModalDelete.bind(this)}
              submit={this.delete.bind(this)}
            />
            { /* eslint-enable react/jsx-no-bind */ }
          </div>
        </div>
      </Fragment>
    )
  }
}

Branch.propTypes = {
  history: PropTypes.object
}

export default Branch



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Branch/Branch.js